// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'

// require styles
import 'swiper/dist/css/swiper.css'

import "babel-polyfill"
import 'es6-promise/auto'
import './assets/font/iconfont.css'
import VueJsonp from 'vue-jsonp'

import store from "./store/index";

Vue.config.productionTip = false
Vue.use(VueJsonp)
Vue.use(VueAwesomeSwiper, /* { default global options } */)

Vue.prototype.$vue = new Vue();

// 全局引入Toast
import './components/Toast/toast.css';
import Toast from './components/Toast/index';
Vue.use(Toast);

import VueQriously from 'vue-qriously';
Vue.use(VueQriously);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js